module.exports = __webpack_public_path__ + "img/slack_act.4d287339.svg";